export const calendarMediaLibraryLocalStorageKey = 'scheduler_calendar_media_library_active';

const defaultValue = true;

export const getCalendarMediaLibraryLocalStorage = () => {
    const valueLocalStorage = localStorage.getItem(calendarMediaLibraryLocalStorageKey);
    return valueLocalStorage ? Boolean(Number(valueLocalStorage)) : defaultValue;
};

export const setCalendarMediaLibraryLocalStorage = (mediaLibrary: boolean) => {
    if (mediaLibrary === defaultValue) {
        localStorage.removeItem(calendarMediaLibraryLocalStorageKey);
        return;
    }
    localStorage.setItem(calendarMediaLibraryLocalStorageKey, JSON.stringify(Number(mediaLibrary)));
};
